
import Layout from "layouts/layout";
import { connect } from "react-redux";
import { useNotifications } from "redux/modules/notification/hooks";
import _ from "lodash";
import NotificationEmpty from "assets/svg/notificationEmpty";
import NotificationContentItem from "components/global/notification/notification-content-item";
import { useTranslation } from "react-i18next";
import { randomExtension,urlSerializer } from "utils/utils";
import { useHistory } from 'react-router-dom';
import { useDialogHook } from "utils/customhooks";
import InvitationNotificationModal from "components/global/notification/invitation-notification";
import InvitationAcceptedModal from "components/global/notification/invitation-accepted";
import InvitationDeclinedModal from "components/global/notification/invitiation-declined";
import React, { useState, useEffect,useRef,useCallback } from "react";
import Lottie from "lottie-react";
import Spinner from "assets/json/spinner.json";
import { useMilestones } from "redux/modules/milestone/hooks";
import toast from "react-hot-toast";

const NotificationPage = ()=>{
    const {  updatePushNotificationUserAccess, 
      total: totalNotifications, 
      fetchNotification,
      loadMore: loadMoreNoti,
      refresh,
      initialize,
      refreshNotification,
      finishGetNotifications,
      notification_page_read,
      // isRequesting,
      setNotifications,
      notificationPage,
      notifications
     } = useNotifications();

    const {emptyTaggedMilestone,taggedMilestones,removeTaggedMilestones} = useMilestones() 
    const {t} = useTranslation()
    const  history  = useHistory();
    const extension = randomExtension();
    const { http } = global.services; 
    const contentRef = useRef();
    const containerStickyRef = useRef();
    const fetchNotiId = useRef(0);
    const [isFetching, setIsFetching] = useState(false);

    const invitationModal = useDialogHook(InvitationNotificationModal);
    const invitationAccepted = useDialogHook(InvitationAcceptedModal);
    const invitationDeclined = useDialogHook(InvitationDeclinedModal);

    let userData = JSON.parse(localStorage.getItem('user_data'));

  const handleScroll = useCallback(_.throttle(() => {
    if (contentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      const middleThreshold = scrollHeight / 3;
      const topClientHeight = scrollTop + clientHeight;

      if (topClientHeight >= middleThreshold) {
        if (!_.isEmpty(userData.profile)) { 
          if (isFetching || !loadMoreNoti) return;
          fetchNotifications();
        }
      }
    }
  }, 500), [userData.profile, isFetching, loadMoreNoti]);

    const fetchNotifications = async () => { 
      let loadMore = false; 
        try {
          setIsFetching(true);
          const requestId = ++fetchNotiId.current;
          const { data } = await http.get("notifications", {
            limit: 20,
            offset: totalNotifications,
            user_id: userData.user.id,
            user_profile_id: userData.profile.id,
            header:Boolean(true)/**Filter for unread */
          });
          if (requestId !== fetchNotiId.current) {
            console.log("Ignoring outdated response");
            return;
          } 
          loadMore = data.total > 0 ? true : false;
          const _total = parseInt(totalNotifications) + data.total;
          fetchNotification({
            data: data.notifications,
            total: _total,
            unread: data.unread
          })
        } catch (err) {
          console.log(err);
        }finally {  
        setIsFetching(false) 
        await finishGetNotifications({
            loadMore: loadMore,
          });
      }
      }

    useEffect(()=>{
      if (refresh) {
            refreshNotification();
          } else if (initialize) {
            if(!_.isEmpty(userData.profile)){
              fetchNotifications() 
            } 
          }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[refresh,initialize])

    async function getNotifications(id) {
        try {
          await http.put(`notifications/${id}/read`);
          const url = urlSerializer("notifications", {
            limit: 5,
            offset: 0,
            user_id: userData.user.id,
            user_profile_id: userData.profile.id,
            header:Boolean(true),
            unreadOnly:Boolean(true)
          });
          const { data } = await http.get(url);
          setNotifications(data);
        } catch (err) {
          console.log(err);
        }
      }

    const handleClick = (data = {}) => {
        console.log(data);
        const type = data.type;
        const { from } = data.user_access_notification || {};

        try{
          let notifications = notificationPage.map(item =>{
          if(item.id === data.id){
            return {
              ...item,
              is_read:true
            }
          }
          return item;
        });

          notification_page_read({
              data: notifications
          });
          getNotifications(data.id)
          switch(type) {
              case "following":
                  // removed and make name clicking makes it go to follower's page
                  // gotoFollowersProfile(from); 
                  return;
              case "new_milestone":
              case "mention_milestone":
                  gotoMilestonePost(data);
                  return;
              case "profile_invite":
                  acceptInvite(data);
                  return;
              default:
                  console.log("no match");
          }
        }catch(e){
          console.error(e);
        }
    };

    const removeFromList = async(e,id)=>{
      e.stopPropagation();
      try {
          setNotifications({notifications:notifications.filter((notif) => notif.id !== id)});
          notification_page_read({
              data: notificationPage.filter((notif) => notif.id !== id)
            })
          await http.put(`notifications/${id}/removed`);
          
        } catch (err) {
          console.log(err);
        }
    }

    const gotoFollowersProfile = (from) => {
        const followerURL = `/${encodeURIComponent(from?.username)}-${randomExtension()}/profile/${encodeURIComponent(from?.profile?.id)}`
        console.log({followerURL});
        history.push(followerURL);
    };

    const gotoMilestonePost = async(item) => {
        // todo: go to milestone post
        const {data} = await http.get(`public/milestone-tag/${item.milestone_id}/${item?.user_profile_id}`);
        if(!data){
          toast.error("This tagged milestone is no longer available.");
          const removedTag = taggedMilestones.filter(milestone => milestone.id !== item.milestone_id);
          removeTaggedMilestones({ data: removedTag, total: removedTag.length })
          return;
        }
        localStorage.setItem("profile-tab",JSON.stringify("tagged"));
        const { from } = item.user_access_notification || {};
        const milestoneId = item.milestone_id;
        //Direct to your own tagged tab
        let followingURL = `/${encodeURIComponent(userData.user?.username)}-${randomExtension()}/profile/${encodeURIComponent(item?.user_profile_id)}`;
        if(milestoneId) {
            followingURL += `?focusMilestone=${encodeURIComponent(milestoneId)}`;
        }
        emptyTaggedMilestone()
        history.replace(followingURL);
    };

    const acceptInvite = (notification) => {
        const { from, user_access } = notification.user_access_notification;
    
        if(user_access?.status === "pending") {
            invitationModal({ notification }, (callBack) => {
              if (callBack.success) {
                updatePushNotificationUserAccess(callBack.data);
                invitationAccepted({ notification }, (cb) => {
                  if (cb) {
                    history.push(
                      `/${from?.username}-${extension}/profile/${from?.profile?.id}`
                    );
                  }
                });
              } else if (callBack.success === false) {
                updatePushNotificationUserAccess(callBack.data);
                invitationDeclined({ notification });
              }
            });
        }

      };

    return(
        <Layout title="Notifications" 
          contentRef={contentRef} 
          handleScroll={handleScroll}
          containerStyle="lg:static lg:overflow-y-auto overflow-x-hidden"
        >
          <div className="auth-page-wrapper pb-8.5" ref={containerStickyRef}> 
              <div className="container mx-auto rounded-md px-6 pt-6.6 w-full 3md:w-2/4"> 
                {
                  !_.isEmpty(notificationPage) ?
                  <>
                      <h1 className="text-xl font-semibold leading-5.5 text-lightBlack mb-4">
                      {t('notification')}
                      </h1>
                      <ul className="w-full grid gap-y-4">
                      { 
                      notificationPage.map((obj, index) => (
                          <div className="bg-white rounded-md py-2 3md:py-4 pl-2">
                          {/* {console.log("::NOTIF", obj)} */}
                          <NotificationContentItem
                          key={index}
                          {...obj}
                          reverse={true}
                              // acceptInvite={() => acceptInvite(obj)}
                              markReadNotification={() => handleClick(obj)}
                              onFollowerNameClick={() => gotoFollowersProfile(obj.user_access_notification?.from)}
                              removeFromList={removeFromList}
                          />
                          </div>
                      ))
                      }
                      {
                        isFetching && 
                        <div className="flex flex-col justify-center items-center my-4">
                          <Lottie animationData={Spinner} className="w-16 h-16" />
                          <p className="text-md font-semibold text-gray-500">Load More</p>
                        </div>
                      }
                      </ul>
                  </>:
                  loadMoreNoti ? 
                    <div className="flex flex-col justify-center items-center my-20">
                      <Lottie animationData={Spinner} className="w-16 h-16" />
                      <p className="text-md font-semibold text-gray-500">Load More</p>
                    </div>:
                    <div className="text-center">
                        <div className="flex justifya-center items-center flex-col">
                        <div>  
                            <NotificationEmpty/>
                        </div>
                        <div className="font-bold text-lg mt-4">{t('noNotifications')}</div>
                        <div className="text-xs mt-1">{t('thereIsNoNotification')}</div>
                        </div>
                    </div>

                }
              </div>
          </div>
        </Layout>
    );
}

const mapStateToProps = (state) => {
    return {
      userData: state.user.userData,
    };
  };

export default connect(mapStateToProps)(NotificationPage);